import { isRoundCancelledSlip, normalizeSlipStatus } from './slipTabFilters'

const ROUND_CANCEL_REASON = /round cancel|ยกเลิกรอบ/i

export type SlipStatusLabels = Record<string, string>

export function isRoundCancellationSlip(slip: {
  status?: string
  refundReason?: string | null
  roundStatus?: string | null
}): boolean {
  if (isRoundCancelledSlip(slip)) return true
  const status = normalizeSlipStatus(slip.status)
  if (status === 'cancelled') return true
  if (status === 'refunded' && ROUND_CANCEL_REASON.test(String(slip.refundReason || ''))) {
    return true
  }
  return false
}

export function getSlipStatusLabel(
  slip: {
    status?: string
    refundReason?: string | null
    roundStatus?: string | null
  },
  labels: SlipStatusLabels,
  fallback = 'รอผล'
): string {
  if (isRoundCancellationSlip(slip)) {
    return labels.cancelled || 'ยกเลิก'
  }
  const status = normalizeSlipStatus(slip.status)
  return labels[status] || status || fallback
}
